module.exports = {
      id: "sports-usage",
      viewBox: "0 0 26.459 26.453",
      url: "/" + "sprite-80884a0dd6365dbc8eb28b3bec27c8f5.svg#sports",
      toString: function () {
        return this.url;
      }
    }